import BankFailures from "../components/BankFailures/BankFailures";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, SortDirection } from "../interfaces";
import { updateSortOrder } from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.failures,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
    updateAggValues: (aggVals: any) => {
      dispatch(
        actions.updateAgg(
          aggVals.agg_by,
          aggVals.agg_term_fields,
          aggVals.agg_sum_fields,
          aggVals.subtotal_by,
          aggVals.total_fields,
        ),
      );
    },
    updateFilter: (filter: string, value: string) => {
      dispatch(actions.updateFilter(filter, value));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BankFailures);
